(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('Membership', Membership);

    Membership.$inject = ['$resource', 'DateUtils'];

    function Membership ($resource, DateUtils) {
        var resourceUrl =  'api/memberships/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.trialStartDate = DateUtils.convertDateTimeFromServer(data.trialStartDate);
                        data.trialEndDate = DateUtils.convertDateTimeFromServer(data.trialEndDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
